module.exports = __webpack_public_path__ + "static/media/sprite-mono.8f4ee575.svg";